import { render, staticRenderFns } from "./CertificateQuarter.vue?vue&type=template&id=4cf9e512&scoped=true"
import script from "./CertificateQuarter.vue?vue&type=script&lang=js"
export * from "./CertificateQuarter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf9e512",
  null
  
)

export default component.exports